export class Cotizacion {
    idCotizacion: number;
    idMoneda: number;
    idCliente: number;
    fDesde: Date = new Date();
    fHasta: Date = new Date();
    valor: number;

    constructor(cotizacion: any = null) {
        if (cotizacion) {
            this.idCotizacion = cotizacion.idCotizacion;
            this.idMoneda = cotizacion.idMoneda;
            this.idCliente = cotizacion.idCliente;
            this.valor = cotizacion.valor;
            this.fDesde = cotizacion.fDesde;
            this.fHasta = cotizacion.fHasta;
        }
    }
}
